import { render, staticRenderFns } from "./common-product-grid.vue?vue&type=template&id=2a916ab0&scoped=true"
import script from "./common-product-grid.vue?vue&type=script&lang=js"
export * from "./common-product-grid.vue?vue&type=script&lang=js"
import style0 from "./common-product-grid.vue?vue&type=style&index=0&id=2a916ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a916ab0",
  null
  
)

export default component.exports